export default "/images/file-plus.svg?cc2671b5bb1e94f9a5de4c2cc888e6e0";